import { render } from "./OptionCard.vue?vue&type=template&id=107c4153&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=js"
export * from "./OptionCard.vue?vue&type=script&lang=js"

import "./OptionCard.vue?vue&type=style&index=0&id=107c4153&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107c4153"]])

export default __exports__